<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="link"
                    label="推荐外链"
                    prop="link"
                    :help="formErr.link"
                    :validateStatus='!formErr.link||formErr.link==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.link"
                        @change="(e) => { formErr.link=''}"
                        @blur="(e) => {  form.link = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="industry_id"
                    label="行业"
                    prop="industry_id"
                    :extra="formErr.industry_id"
                    :validateStatus='!formErr.industry_id||formErr.industry_id==""?"":"error"'
            >
                <a-select v-model="form.industry_id">
                    <a-select-option :value="item.id" v-for="(item, idx) in industry" :key="idx">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="da"
                    label="DA"
                    prop="da"
                    :help="formErr.da"
                    :validateStatus='!formErr.da||formErr.da==""?"":"error"'
            >
                <a-input-number v-model="form.da"  @change="(e) => {daCheck; formErr.da=''}" />
<!--                :precision="2"-->
            </a-form-model-item>
            <a-form-model-item
                    ref="is_follow"
                    label="是否传递权重"
                    prop="is_follow"
                    :extra="formErr.is_follow"
                    :validateStatus='!formErr.is_follow||formErr.is_follow==""?"":"error"'
            >
                <a-select v-model="form.is_follow">
                    <a-select-option :value="item.value" v-for="(item, idx) in is_follow" :key="idx">
                        {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="1"> 发布 </a-radio>
                    <a-radio :value="0"> 草稿 </a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";

    export default {
        name: "newForm",
        props: ["visible","title","editId"],
        data() {
            return {
                drawerConfig ,
                role:[],
                form: {
                    link:"",
                    industry_id:"",
                    da:"",
                    is_follow:0,
                    status:1,
                },
                formErr: {
                    link:"",
                    industry_id:"",
                    da:"",
                    is_follow:"",
                    status:"",
                },
                 industry:[],
                 is_follow:[],
                 status:[],
                rules: {
                    industry_id: [{required: true, message: "请输入行业 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.industry_id)}, trigger: "blur"  },],
                    da: [{required: true, message: "请输入DA ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.da)}  , trigger: "blur"  }, ],
                    link: [{required: true, message: "请输入推荐外链 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.link)}  , trigger: "blur"  },  ],
                    is_follow: [{required: true, message: "请输入是否传递权重 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.is_follow)}  , trigger: "blur"  },  ],

                },
                layout: {
                    labelCol: { span: 4 },
                    wrapperCol: { span: 14 },
                },
            };
        },
        computed: {
            daCheck: function () {
                let da=this.form.da
                let newNumber= null
                if (da >= 0) {
                    let reg = /.*\..*/
                    if (reg.test(da)) {
                        newNumber= Number(da).toFixed(2)
                    } else {
                        newNumber= da
                    }
                }
                this.form.da= newNumber
            }
        },
        watch:{
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let val = res.data.data.info
                        this.form = val
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''
                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {


            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.industry=res.data.data.industry
                    this.is_follow=res.data.data.is_follow
                    this.status=res.data.data.status
                })
            },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={ link:"", industry_id:"", da:"",  is_follow:"", status:"", }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        this.form.id == '' || this.form.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, _this.form).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    if(item.field=='check_link'){this.formErr.link = item.msg}
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>

</style>
